import type { PermissionCatalogItem } from "@/types/permission-catalog";

const createPermission = (
  category: string,
  resource: string,
  action: "read" | "administrate",
  label: string,
  description: string,
): PermissionCatalogItem => ({
  key: `${resource}:${action}`,
  resource,
  action,
  label,
  description,
  category,
});

export const TENANT_PERMISSION_CATALOG: PermissionCatalogItem[] = [
  createPermission(
    "Hotel Brands",
    "hotel_brands",
    "read",
    "Read hotel brands",
    "View hotel brands and their configuration",
  ),
  createPermission(
    "Hotel Brands",
    "hotel_brands",
    "administrate",
    "Administrate hotel brands",
    "Create / edit / delete hotel brands",
  ),
  createPermission(
    "Users",
    "users",
    "read",
    "Read users",
    "View users, groups, and custom roles",
  ),
  createPermission(
    "Users",
    "users",
    "administrate",
    "Administrate users",
    "Create / edit / delete users, groups, and custom roles",
  ),
  createPermission(
    "Billing",
    "billing",
    "read",
    "Read billing",
    "View billing settings, transactions, and subscriptions",
  ),
  createPermission(
    "Billing",
    "billing",
    "administrate",
    "Administrate billing",
    "Manage billing settings and payment methods",
  ),
  createPermission(
    "Billing",
    "partners",
    "read",
    "Read partners",
    "View partner integrations and configurations",
  ),
  createPermission(
    "Billing",
    "partners",
    "administrate",
    "Administrate partners",
    "Create / edit / delete partner integrations",
  ),
  createPermission(
    "Analytics",
    "analytics",
    "read",
    "Read analytics",
    "View dashboards and reports",
  ),
  createPermission(
    "Analytics",
    "analytics",
    "administrate",
    "Administrate analytics",
    "Export analytics and configure dashboards",
  ),
  createPermission(
    "Settings",
    "settings",
    "read",
    "Read settings",
    "View tenant-level settings",
  ),
  createPermission(
    "Settings",
    "settings",
    "administrate",
    "Administrate settings",
    "Manage tenant-level settings",
  ),
];
